import request from '@/axios';

export const getBlackDeviceIpList = (data) => {
  return request({
    url: '/lebo-ad/blackDeviceIp/page',
    method: 'get',
    params: data
  })
}

export const deleteBlackDeviceIp = (id) => {
  return request({
    url: '/lebo-ad/blackDeviceIp/delete/' + id,
    method: 'post'
  })
}

export const batchRemove = (ids) => {
  // 将ids按逗号分隔，并转为数字数组
  const arr = ids.split(',').map(id => Number(id));
  return request({
    url: '/lebo-ad/blackDeviceIp/batchDelete',
    method: 'post',
    params: { ids: arr }
  })
}

export const add = (row) => {
  return request({
    url: '/lebo-ad/blackDeviceIp/add',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/lebo-ad/blackDeviceIp/update',
    method: 'post',
    data: row
  })
}
